export default __webpack_public_path__ + "static/media/nasa.85c58c85.png";